import React from "react";
import { defineMessages, FormattedMessage } from "react-intl";

import Icon from "../../../../../icon";

import { StyledNotEdited, Alert } from "./styles";

const messages = defineMessages({
    notEdited: {
        id: "test.taskCard.notEdited",
    },
});

const NotEdited = () => (
    <StyledNotEdited>
        <div>
            <Alert>
                <Icon i="alert" />
            </Alert>
            <FormattedMessage {...messages.notEdited} />
        </div>
    </StyledNotEdited>
);

export default NotEdited;
